import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { UiModule } from '../../ui';
import { SharedUiModule } from '../../../shared/ui';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { DLRootCertificateService } from './root-certificate.service';
import { DLRootCertificateResolver } from './root-certificate.resolver';
import { DLRootCertificateListComponent } from './root-certificate-list.component';
import { DLRootCertificateEditComponent } from './root-certificate-edit.component';
import { DLRootCertificateFilterDialogComponent } from './root-certificate-filter-dialog.component';

@NgModule({
  imports: [
    BrowserModule,
    SharedUiModule,
    UiModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    RouterModule,
  ],
  declarations: [
    DLRootCertificateListComponent,
    DLRootCertificateEditComponent,
    DLRootCertificateFilterDialogComponent,
  ],
  providers: [
    DLRootCertificateService,
    DLRootCertificateResolver,
  ],
  bootstrap: [
    DLRootCertificateFilterDialogComponent,
  ]
})
export class DLRootCertificateModule { }
